import Indicador from ".."
import EditFields from "./components/EditFields"
// import MMGraficoPainel from "./components/MMGraficoPainel"
// import MMGraficoRelatorio from "./components/MMGraficoRelatorio"
import { ParamFields } from "./components/ParamFields"
import Report from "./reports"
import ReportSummary from "./reports/summary"

export default class MudaMecanizada extends Indicador {
    static get fullName() {
        return "Muda Mecanizada"
    }

    static get abbrev() {
        return "MM"
    }

    static get field() {
        return "mudaMecanizada"
    }

    static get legacyApontamentoMap() {
        return {
            dataHora: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            talhao: "talhao",
            frente: "frente",

            turno: "turno",
            georeferencia: "georeferencia",

            tamToletesPicados: "tamToletesPicados",
            entrenosRachados: "entrenosRachados",
            nosRachados: "nosRachados",
            gemasDanificadas: "gemasDanificadas",
            palmitoAgregado: "palmitoAgregado",

            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        }
    }

    static get legacyParamMap() {
        return {
            mmMetaManual: "manual.meta",

            mmMetaMecanizado: "mecanizado.meta",
        }
    }

    static paramFields(tipoIndicadorField = '') {
        return <ParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <EditFields visita={visita} isNew={isNew} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <MMGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return MMGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return Report(this, visita)
    }

    async renderReportSummary(visita, tipoName) {
        return ReportSummary(this, visita, tipoName)
    }

    static calcConformidade(apontamento, params) {
        if (!params) {
            return 0
        }

        // porcentagem do quanto está conforme
        apontamento.tamToletesPicados = ((apontamento.totalConformeTamToletesPicados * 100) / apontamento.totalAvaliadoTamToletesPicados).toFixed(2)
        apontamento.entrenosRachados = ((apontamento.totalConformeEntrenosRachados * 100) / apontamento.totalAvaliadoEntrenosRachados).toFixed(2)
        apontamento.nosRachados = ((apontamento.totalConformeNosRachados * 100) / apontamento.totalAvaliadoNosRachados).toFixed(2)
        apontamento.gemasDanificadas = ((apontamento.totalConformeGemasDanificadas * 100) / apontamento.totalAvaliadoGemasDanificadas).toFixed(2)
        apontamento.palmitoAgregado = ((apontamento.totalConformePalmitoAgregado * 100) / apontamento.totalAvaliadoPalmitoAgregado).toFixed(2)

        return ''
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatus(conformidade, meta, 80, 90, 98)
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) { // pdf da tela de relatórios
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Turno", field: "turno", width: 'auto' },

            {
                title: "T.T.P.(%)",
                field: "tamToletesPicados",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.tamToletesPicados, paramsCliente?.tamToletesPicados))
                }
            },
            {
                title: "E.R.(%)",
                field: "entrenosRachados",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.entrenosRachados, paramsCliente?.entrenosRachados))
                }
            },
            {
                title: "N.R.(%)",
                field: "nosRachados",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.nosRachados, paramsCliente?.nosRachados))
                }
            },
            {
                title: "G.D.(%)",
                field: "gemasDanificadas",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.gemasDanificadas, paramsCliente?.gemasDanificadas))
                }
            },
            {
                title: "P.A. (%)",
                field: "palmitoAgregado",
                width: 38,
                getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.palmitoAgregado, paramsCliente?.palmitoAgregado))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Tamanho de Toletes Picados: " + apontamento.tamToletesPicados +
            ", Entrenós Rachados: " + apontamento.entrenosRachados +
            ", Nós Rachados: " + apontamento.nosRachados +
            ", Gemas Danificadas: " + apontamento.gemasDanificadas +
            " e Palmito Agregado: " + apontamento.palmitoAgregado
    }
}
